"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("../models/globals");
class Graphiques extends webix_jet_1.JetView {
    constructor() {
        super(...arguments);
        this.articlesNombreMaxi = 400;
        this.articlesNombreReel = 1;
        this.clientsNombreMaxi = 2;
        this.clientsNombreReel = 1;
        this.documentsNombreMaxi = 2;
        this.documentsNombreReel = 1;
        this.lignesNombreMaxi = 2;
        this.lignesNombreReel = 1;
        // comptage des documents créés, par mois pendant les 15 derniers mois
        this.dataset = [
            { id: 1, documents: 20, mois: "01" },
            { id: 2, documents: 55, mois: "02" },
            { id: 3, documents: 40, mois: "03" },
            { id: 4, documents: 78, mois: "04" },
            { id: 5, documents: 61, mois: "05" },
            { id: 6, documents: 0, mois: "06" },
            { id: 7, documents: 0, mois: "07" },
            { id: 8, documents: 0, mois: "08" },
            { id: 9, documents: 78, mois: "09" },
            { id: 10, documents: 61, mois: "10" },
            { id: 11, documents: 35, mois: "11" },
            { id: 12, documents: 55, mois: "12" },
            { id: 13, documents: 40, mois: "13" },
            { id: 14, documents: 78, mois: "14" },
            { id: 15, documents: 61, mois: "15" }
        ];
        // Echelle
        this.yStart = 0;
        this.yEnd = 100; // valeurs : 40,100,200,400, *2
        this.yStep = 20; // 10,20,40,80, *2
    }
    config() {
        return {
            height: 700,
            // width: 1500,
            rows: [
                {
                    cols: [
                        {
                            rows: [
                                {
                                    template: "<div style='width:100%;text-align:center;font-size:12px'>Nombre de produits</div>",
                                    height: 30
                                },
                                {
                                    view: "chart", id: "chart1",
                                    donutInnerText: function (data, total) {
                                        return "<span style='font-size:12px'>Produits</span><br>";
                                    },
                                    type: "donut", innerRadius: 40, value: "#valeur#", color: "#color#",
                                    label: "#etiquette#", pieInnerText: "#valeur#", shadow: 0,
                                }
                            ]
                        },
                        {
                            rows: [
                                {
                                    template: "<div style='width:100%;text-align:center'>Nombre de clients</div>",
                                    height: 30
                                },
                                {
                                    view: "chart", id: "chart2",
                                    donutInnerText: function (data, total) {
                                        return "<span style='font-size:12px'>Clients</span><br>";
                                    },
                                    type: "donut", innerRadius: 40, value: "#valeur#", color: "#color#",
                                    label: "#etiquette#", pieInnerText: "#valeur#", shadow: 0,
                                }
                            ]
                        },
                        {
                            rows: [
                                {
                                    template: "<div style='width:100%;text-align:center'>Nombre de documents</div>",
                                    height: 30
                                },
                                {
                                    view: "chart", id: "chart3",
                                    donutInnerText: function (data, total) {
                                        return "<span style='font-size:12px'>Documents</span><br>";
                                    },
                                    type: "donut", innerRadius: 40, value: "#valeur#", color: "#color#",
                                    label: "#etiquette#", pieInnerText: "#valeur#", shadow: 0,
                                }
                            ]
                        },
                        {
                            rows: [
                                {
                                    template: "<div style='width:100%;text-align:center'>Nombre de lignes de documents</div>",
                                    height: 30
                                },
                                {
                                    view: "chart", id: "chart4",
                                    donutInnerText: function (data, total) {
                                        return "<span style='font-size:12px'>Lignes</span><br>";
                                    },
                                    type: "donut", innerRadius: 40, value: "#valeur#", color: "#color#",
                                    label: "#etiquette#", pieInnerText: "#valeur#", shadow: 0,
                                }
                            ]
                        }
                    ]
                },
                {
                    cols: [
                        {
                            rows: [
                                {
                                    template: "<div style='width:100%;text-align:center'>Documents par mois</div>",
                                    height: 30
                                },
                                {
                                    view: "chart", type: "bar", id: "chart5",
                                    value: "#nombre#", color: "#color#", label: "#nombre#",
                                    shadow: 0,
                                    xAxis: {
                                        template: "#mois#"
                                    },
                                    width: 600
                                }
                            ]
                        },
                        { rows: [
                                {
                                    template: "<div style='width:100%;text-align:center'>Chiffre d'affaires par mois</div>",
                                    height: 30
                                }, {
                                    view: "chart", type: "line", id: "chart6",
                                    value: "#totalHT#",
                                    item: { borderColor: "#ffffff", color: "#2b7100" },
                                    tooltip: { template: "#totalHT#" },
                                    line: { color: "#8ecf03", width: 2, shadow: true },
                                    xAxis: {
                                        template: "#mois#"
                                    },
                                    width: 600
                                    // yAxis: {
                                    //     start: this.yStart,
                                    //     step: this.yStep,
                                    //     end: this.yEnd,
                                    //     // template:function(value) { return value%20?"":value}
                                    // },
                                }
                            ]
                        },
                        {
                            type: "line",
                            value: "#contrat#",
                            item: {
                                radius: 2,
                                borderColor: "#7fa505"
                            },
                            line: {
                                color: "#7fa505",
                                width: 2
                            },
                            data: [
                                { id: 1, documents: 20, mois: "01" },
                                { id: 2, documents: 20, mois: "02" },
                                { id: 3, documents: 20, mois: "03" },
                                { id: 4, documents: 20, mois: "04" }
                            ]
                        }
                    ]
                }
            ]
        };
    }
    init(baseview) {
        this.moduleName = "graphiques";
        let me = this;
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "parametres.php?key=graphiques.data&option=readjson");
        promise.then(function (result) {
            let vv = result.json();
            me.articlesNombreMaxi = vv.articles.nombreMaxi;
            me.clientsNombreMaxi = vv.clients.nombreMaxi;
            me.documentsNombreMaxi = vv.documents.nombreMaxi;
            me.lignesNombreMaxi = vv.lignes.nombreMaxi;
        });
        // @ts-ignore
        let promise2 = webix.ajax().get(globals_1.phpPath + "graphiques.php?option=all");
        promise2.then(function (result) {
            let vv = result.json();
            // Articles
            me.articlesNombreReel = parseInt(vv[0]["articlesNombreReel"], 10);
            let gart = $$("chart1");
            gart.add({ valeur: me.articlesNombreReel, etiquette: "Libre", color: "#ee3639" });
            gart.add({ valeur: me.articlesNombreMaxi - me.articlesNombreReel, etiquette: "Produits", color: "#ee9e36" });
            // Clients
            me.clientsNombreReel = parseInt(vv[1]["clientsNombreReel"], 10);
            let gcli = $$("chart2");
            gcli.add({ valeur: me.clientsNombreReel, etiquette: "Existants", color: "#ee3639" });
            gcli.add({ valeur: me.clientsNombreMaxi - me.clientsNombreReel, etiquette: "Place libre", color: "#ee9e36" });
            // Documents
            me.documentsNombreReel = parseInt(vv[2]["documentsNombreReel"], 10);
            let gdoc = $$("chart3");
            gdoc.add({ valeur: me.documentsNombreReel, etiquette: "Existants", color: "#ee3639" });
            gdoc.add({ valeur: me.documentsNombreMaxi - me.documentsNombreReel, etiquette: "Place libre", color: "#ee9e36" });
            // Lignes
            me.lignesNombreReel = parseInt(vv[3]["documentsLignesNombreReel"], 10);
            let glig = $$("chart4");
            glig.add({ valeur: me.lignesNombreReel, etiquette: "Existants", color: "#ee3639" });
            glig.add({ valeur: me.lignesNombreMaxi - me.lignesNombreReel, etiquette: "Place libre", color: "#ee9e36" });
            // Nombre de documents par mois
            let gndoc = $$("chart5");
            let docs = vv[4]["documents"];
            let i = 0;
            while (docs[i]) {
                let vv = docs[i];
                let mois = vv.mm + "/" + vv.aa;
                gndoc.add({ "nombre": vv.nombre, "mois": mois, "color": "#9c8ee4" });
                i++;
            }
            // Chiffre d'affaires par mois
            let gcam = $$("chart6");
            docs = vv[4]["documents"];
            me.yEnd = docs.maxCA;
            me.yStart = docs.minCA;
            me.yStep = 1000;
            gcam.define("yAxis", {
                start: me.yStart,
                step: me.yStep,
                end: me.yEnd
            });
            gcam.refresh();
            i = 0;
            while (docs[i]) {
                let vv = docs[i];
                let mois = vv.mm + "/" + vv.aa;
                gcam.add({ "totalHT": vv.totalHT, "mois": mois, "color": "#9c8ee4" });
                i++;
            }
        });
    }
}
exports.default = Graphiques;
